import { useEffect, useState } from "react";
import { Dispatch } from "redux";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";

import { createUserDetails } from "services/requests/v1/user";

import {
    SetRequestError,
    SubscribeContentType,
    UnsubscribeContentType,
} from "types/generic";

import GoAiguaModal from "components/generic/goaiguamodal";
import UserModalContent from "./usermodalcontent";

import { isTokenKCApiExpired } from "utils/functions";
import axios, { AxiosError } from "axios";

type CreateUserModalType = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    userUid?: string;
    token: string;
    subscribeContent: SubscribeContentType;
    unsubscribeContent: UnsubscribeContentType;
    setError: SetRequestError;
};

const CreateUserModal: React.FC<CreateUserModalType> = ({
    isOpen,
    setIsOpen,
    userUid,
    token,
    subscribeContent,
    unsubscribeContent,
    setError,
}) => {
    const intl = useIntl();

    const [metadata, setMetadata] = useState<any>(null);
    const [triggerCreate, setTriggerCreate] = useState<boolean>(false);

    const [isInfoModalOpen, setIsInfoModalOpen] = useState<boolean>(false);

    const {
        keycloak,
    }: {
        initialized: boolean;
        keycloak: Keycloak.KeycloakInstance;
    } = useKeycloak();

    useEffect(() => {
        const contentName = "createUser";

        if (triggerCreate) {
            subscribeContent(contentName);

            (async () => {
                try {
                    await createUserDetails({
                        email: metadata.email,
                        enabled: metadata.enabled,
                        firstName: metadata.firstName,
                        lastName: metadata.lastName,
                        username: metadata.username,
                        password: metadata.password,
                        locale: metadata.locale,
                        telephone: metadata.telephone,
                        realmRoles: metadata.allowedPermissions,
                    });

                    unsubscribeContent(contentName, true);
                } catch (error) {
                    let customErrorMessage: string | undefined;

                    if ((error as AxiosError).response?.status === 409) {
                        customErrorMessage = intl.formatMessage({
                            id: "app.users.user_exist",
                        });
                    }

                    setError(contentName, customErrorMessage);
                }
            })();
            setIsInfoModalOpen(true);
            setTriggerCreate(false);
        }
    }, [triggerCreate]);

    useEffect(() => {
        if (isTokenKCApiExpired(token)) {
            keycloak.logout();
        }
        // Depends on every action that will need KC API Call
    }, [token, isOpen, isInfoModalOpen]);

    return (
        <GoAiguaModal
            headerTitle={intl.formatMessage({ id: "app.users.new_user" })}
            isOpen={isOpen}
            className="create-user"
            setIsOpen={setIsOpen}
        >
            <UserModalContent
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                editUserModal={false}
                userUid={userUid}
                metadata={metadata}
                setMetadata={setMetadata}
                setCallbackTrigger={setTriggerCreate}
                subscribeContent={subscribeContent}
                unsubscribeContent={unsubscribeContent}
                setError={setError}
            />
        </GoAiguaModal>
    );
};

const mapStateToProps = (state: any) => {
    return {
        token: state.keycloak.token,
    };
};
const mapDispatchToProps = (dispatch: Dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUserModal);
